import i18next from 'i18next';

import { updateContent } from 'common/api/v1/core';
import { showReponseErrorsAsAlert } from 'common/utils/helpers';
import showToast from 'common/utils/showToast';

import {
    UPDATE_TEMPLATE,
    UPDATE_TEMPLATE_SUCCESS,
    UPDATE_TEMPLATE_FAILURE,
} from '../actionTypes';
import { multiTemplateReviewActions } from '../reducer';

export default (contentId, getTemplateUpdatedData, setTemplateBackup) =>
    (dispatch) => {
        dispatch(multiTemplateReviewActions[UPDATE_TEMPLATE]());
        const updatedData = getTemplateUpdatedData();

        updateContent(contentId, {
            content: JSON.stringify(updatedData),
        })
            .then(() => {
                dispatch(multiTemplateReviewActions[UPDATE_TEMPLATE_SUCCESS]());
                setTemplateBackup(true);

                showToast({
                    body: i18next.t('Changes were saved successfully'),
                });
            })
            .catch((error) => {
                dispatch(
                    multiTemplateReviewActions[UPDATE_TEMPLATE_FAILURE](
                        error?.response?.data?.errors,
                    ),
                );
                showReponseErrorsAsAlert(dispatch, error?.response);
            });
    };
